import { createBrowserHistory, createHashHistory, createMemoryHistory, History } from 'history';

let historyTemp: History | null = null;

// create history based on env
const createHistory = () => {
	if (typeof window === 'undefined') {
		// window object exists only on browser
		historyTemp = createMemoryHistory();
	} else if (typeof window !== 'undefined' && window.location.hash) {
		// if it is rendered to old front end which has hashhistory
		historyTemp = createHashHistory();
	} else {
		historyTemp = createBrowserHistory();
	}

	return historyTemp;
};

// create history if it is missing
export const history: History = historyTemp === null ? createHistory() : historyTemp;
